import { render } from "./Facets.vue?vue&type=template&id=7f05d08f"
import script from "./Facets.vue?vue&type=script&lang=js"
export * from "./Facets.vue?vue&type=script&lang=js"

import "./Facets.vue?vue&type=style&index=0&id=7f05d08f&thisd=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__